@let i = iso();

<lvr-heading>
	{{ 'integration_service_office.details.title' | transloco: { name: i?.remark } }}
</lvr-heading>

<section class="grid">
	<!-- Column 1 -->
	<div class="column">
		<h3>
			<mat-icon class="material-symbols-outlined" aria-hidden="true">apartment</mat-icon>
			<span>{{ 'integration_service_office.details.iso' | transloco }}</span>
		</h3>

		<div class="info">
			<p class="name">{{ i?.remark }}</p>
			<div class="details">
				<p>{{ 'integration_service_office.details.current_full_time_positions' | transloco }} {{ i?.fullTimeJobs }}</p>
			</div>
		</div>

		<h3>
			<mat-icon class="material-symbols-outlined" aria-hidden="true">phone_in_talk</mat-icon>
			<span>{{ 'integration_service_office.details.communication_ways' | transloco }}</span>
		</h3>

		<div class="communication">
			<p class="label">{{ 'integration_service_office.details.preferred_communication' | transloco }}</p>
			@if (preferredCommunicationWay()) {
				@if (preferredCommunicationWay()!.categoryContactPointId === CONTACT_POINT_TYPE.PHONE) {
					<p>
						<a [href]="'tel:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				} @else if (preferredCommunicationWay()!.categoryContactPointId === CONTACT_POINT_TYPE.EMAIL) {
					<p>
						<a [href]="'mailto:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				} @else {
					<p>{{ preferredCommunicationWay()!.contactValue }}</p>
				}
				<p>{{ preferredCommunicationWay()!.remark }}</p>
			} @else {
				<p>{{ 'integration_service_office.details.no_preferred_communication' | transloco }}</p>
			}

			<!-- Additional communication ways -->
			@if (communicationWays().length >= 1) {
				<cdk-accordion lvrPadding [padHorizontal]="0" [padVertical]="0">
					<cdk-accordion-item #accordionItem="cdkAccordionItem">
						<button
							matButton
							class="trailing-icon-button"
							(click)="accordionItem.toggle()"
							tabindex="0"
							[attr.id]="'accordion-header'"
							[attr.aria-expanded]="accordionItem.expanded"
							[attr.aria-controls]="'accordion-body'"
						>
							<span class="label">
								{{ 'integration_service_office.details.other_communication' | transloco }}
							</span>
							@if (accordionItem.expanded) {
								<mat-icon>keyboard_arrow_up</mat-icon>
							} @else {
								<mat-icon>keyboard_arrow_down</mat-icon>
							}
						</button>
						@if (accordionItem.expanded) {
							<section
								role="region"
								[style.display]="accordionItem.expanded ? '' : 'none'"
								[attr.id]="'accordion-body'"
								[attr.aria-labelledby]="'accordion-header'"
							>
								@for (cp of communicationWays(); track cp.id) {
									<div lvrBorder borderPosition="bottom" lvrPadding [padHorizontal]="8" [padVertical]="0">
										@if (cp.categoryContactPointId === 1) {
											<p>
												<a [href]="'tel:' + cp.contactValue">
													{{ cp.contactValue }}
												</a>
											</p>
										} @else if (cp.categoryContactPointId === 2) {
											<p>
												<a [href]="'mailto:' + cp.contactValue">
													{{ cp.contactValue }}
												</a>
											</p>
										} @else {
											<p>{{ preferredCommunicationWay()!.contactValue }}</p>
										}
										<p style="margin-top: 16px">{{ cp.remark }}</p>
									</div>
								}
							</section>
						}
					</cdk-accordion-item>
				</cdk-accordion>
			}
		</div>
	</div>

	<!-- Column 2 -->
	<div class="column">
		<h3>
			<mat-icon class="material-symbols-outlined" aria-hidden="true">location_on</mat-icon>
			<span>{{ 'integration_service_office.details.address' | transloco }}</span>
		</h3>

		<address>
			<p [attr.aria-label]="'base.field.street_address' | transloco">
				{{ i?.address?.streetAndHouseNumber }}
			</p>
			<p [attr.aria-label]="'base.field.postal_code_and_city' | transloco">
				{{ i?.address?.postalCodeAndCity }}
			</p>
		</address>
	</div>
</section>
